
import { useContext, useMemo } from 'react'
import { ThemeContext } from '../context'

export function useColorMode() {
  const context = useContext(ThemeContext)
  
  const r = useMemo(() => {
    const {
      colorMode,
      setColorMode,
      toggleColorMode,      
    } = context

    return {
      colorMode,
      setColorMode,
      toggleColorMode,
    }
  }, [context])

  return r
}